import {
  ActionHeader,
  StyledFlex,
  StyledGridCol,
  StyledGridRow,
} from "@/common/styles";
import Button from "@/common/elements/Button";
import { useEffect, useState } from "react";
import Modal from "@/common/elements/Modal";
import Table from "@/common/elements/Table";
import { Col, Row } from "react-bootstrap";
import FormItem from "@/common/elements/InputElements/FormItem.jsx";
import TextField from "@/common/elements/InputElements/TextField";
import Select from "@/common/elements/InputElements/Select";
import {
  getOptionsFromRefList,
  hasCheckSecurity,
  isNonEmptyVariable,
} from "@/util/common_function";
import { Form, Popconfirm } from "antd";
import dayjs from "dayjs";
import { useDispatch, useSelector } from "react-redux";
import CommonDatePicker from "@/common/elements/DatePicker";
import { setBookings, setDeleteAPis } from "@/slices/bookingsSlice";
import { v4 as uuidv4 } from "uuid";
import CommonReportModal from "../CommonReport/CommonReportModal";
import CustomModal from "../CustomModal";
import { useAsyncError } from "react-router-dom";
import API_ENDPOINTS from "@/util/api";
import api from "@/services/axios_custom";
import notificationService from "@/util/notificationService";
import { Entity_types, Security_Types } from "@/util/permission_bits";
import { LABELS_CAPITAL } from "@/util/usePermissionMask";
import {
  MODULES_LIST_WITH_ID,
  SUB_MODULES_LIST_WITH_ID,
} from "@/util/common_variable";

const BillingDetails = () => {
  const [billingForm] = Form.useForm();
  const [reportOptionsForm] = Form.useForm(); // New form for report options
  const dispatch = useDispatch();
  const { bookings, bookingsFieldsEnabled } = useSelector(
    (state) => state?.bookings
  );
  const [billingData, setBillingData] = useState([]);
  const [isRowSelected, setIsRowSelected] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [selectedBillingId, setSelectedBillingId] = useState(null);
  const [showBillingDetails, setShowBillingDetails] = useState(false);
  const [showBillingReport, setShowBillingReport] = useState(false);
  const [billingReportOptionModal, setBillingReportOptionModal] =
    useState(false);
  const [billingReportResults, setBillingReportResults] = useState([]);
  const [formData, setFormData] = useState({
    housedFor: null,
    facilityID: null,
    startDate: dayjs(new Date()),
    endDate: dayjs(new Date()),
    billingRate: null,
    comments: null,
  });
  const [isEdit, setIsEdit] = useState(false);
  const [isDisabled, setIsDisabled] = useState(false);
  const clickBillingDetails = (val) => {
    setShowBillingDetails(true);
    if (val == "edit") {
      setIsEdit(true);
    }
  };

  const fullSearch = useSelector((state) => state.fullSearch);

  const headers = [
    { key: "housedForLbl", text: "Housed For" },
    { key: "facilityLbl", text: "Facility" },
    { key: "startDate", text: "Start Date" },
    { key: "endDate", text: "End Date" },
    { key: "billingRate", text: "Billing Rate" },
  ];

  useEffect(() => {
    setBillingData(bookings?.inmateBilling || []);
  }, [bookings]);

  const addBilling = () => {
    billingForm.setFieldsValue({
      housedFor: null,
      facilityID: null,
      startDate: null,
      endDate: null,
      billingRate: null,
      comments: null,
    });
    clickBillingDetails();
    setIsRowSelected(false);
    setSelectedRow(null);
    setSelectedBillingId(null);
  };

  const patchSelectedData = (data) => {
    billingForm.setFieldsValue({
      ...data,
      housedFor: parseInt(data.housedFor),
      facilityID: parseInt(data.facilityID),
      startDate: isNonEmptyVariable(data?.startDate)
        ? dayjs(data.startDate)
        : fullSearch
        ? null
        : new Date(),
      endDate: isNonEmptyVariable(data?.endDate)
        ? dayjs(data.endDate)
        : fullSearch
        ? null
        : new Date(),
    });
    setIsRowSelected(true);
    setSelectedRow(data);
    setSelectedBillingId(data.inmateBillingID || data.id);
  };

  const saveBillingReport = () => {
    billingForm
      .validateFields()
      .then((values) => {
        values.startDate = isNonEmptyVariable(values?.startDate)
          ? dayjs(values?.startDate).format("MM/DD/YYYY")
          : null;
        values.endDate = isNonEmptyVariable(values?.endDate)
          ? dayjs(values?.endDate).format("MM/DD/YYYY")
          : null;
        values.billingRate = parseFloat(
          values.billingRate?.replace(/[$,]/g, "") || null
        );
        values.housedFor = parseInt(values?.housedFor);
        if (selectedBillingId) {
          let data = [...billingData];
          data = data?.map((p) =>
            p?.inmateBillingID === selectedBillingId ||
            p?.id === selectedBillingId
              ? { ...p, ...values }
              : p
          );
          updateReleaseNotes(data);
        } else {
          const newData = {
            ...values,
            id: uuidv4(),
          };
          const data = [...billingData, newData];
          updateReleaseNotes(data);
        }
        setShowBillingDetails(false);
        setSelectedRow(null);
        setIsRowSelected(false);
      })
      .catch((err) => console.log(err));
  };

  const updateReleaseNotes = (tb) => {
    dispatch(
      setBookings({
        inmateBilling: [...tb],
      })
    );
  };

  const getFieldLabel = (fieldName, id) => {
    return getOptionsFromRefList(fieldName, false, false, true).filter(
      (data) => parseInt(id) === data?.value
    )?.[0]?.label;
  };

  const deleteBilling = () => {
    const tempArray = billingData?.filter(
      (item) =>
        (item?.inmateBillingID &&
          item?.inmateBillingID !== selectedBillingId) ||
        (item?.id && item?.id !== selectedBillingId)
    );
    updateReleaseNotes(tempArray);
    const url = API_ENDPOINTS.billing + "/" + selectedBillingId;
    dispatch(setDeleteAPis(url));
    setSelectedBillingId(null);
    setIsRowSelected(false);
    setSelectedRow(null);
  };

  const handleBillingReport = () => {
    setBillingReportOptionModal(true);
    reportOptionsForm.resetFields();
  };

  const handleBillingReportModal = () => {
    setShowBillingReport(!showBillingReport);
  };

  const handleReportOptionSave = () => {
    reportOptionsForm
      .validateFields()
      .then(async (data) => {
        setBillingReportOptionModal(false);
        const { startingDate, endingDate, facilityId, housedFor } = data;
        const startDateFormatted = dayjs(startingDate).format("MM/DD/YYYY");
        const endDateFormatted = dayjs(endingDate).format("MM/DD/YYYY");
        const response = await api.post(API_ENDPOINTS.inmateBillingReport, {
          startDate: startDateFormatted,
          endDate: endDateFormatted,
          facilityId,
          housedFor,
        });
        const result = response.data;
        setBillingReportResults(result || []);
        reportOptionsForm.resetFields();
        handleBillingReportModal();
      })
      .catch((err) => {
        console.log("error in fetching billing report : ", err);
        return;
      });
  };

  // Function to format input as currency
  const formatCurrency = (amount) => {
    if (amount === "" || amount === undefined) return ""; // Allow clearing input
    const num = parseFloat(amount.replace(/[^0-9.]/g, "")); // Remove non-numeric characters
    if (isNaN(num)) return ""; // Prevent NaN issues
    return `$${num.toLocaleString("en-US", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    })}`;
  };

  // Handle user input
  const handleChange = (e) => {
    const rawValue = e.target.value.replace(/[^0-9.]/g, ""); // Allow only numbers and a dot
    billingForm.setFieldValue("billingRate", rawValue);
  };

  // Format value on blur (when user leaves the field)
  const handleBlur = (e) => {
    billingForm.setFieldValue("billingRate", formatCurrency(e?.target?.value)); // Apply currency formatting on blur
  };

  const BillingReportHeader = ({ billingReportResults }) => {
    return (
      <StyledFlex justify="center">
        <div className="report-top-header">
          <div className="report-subtle-tile">
            BI2 technologies - Inmate Billing Report{" "}
            {billingReportResults?.billingReportStartDate} -{" "}
            {billingReportResults?.billingReportEndDate}
          </div>
          <h1 className="report-primary-tile">ANOKA COUNTY JAIL ANOKA. MN</h1>
        </div>
      </StyledFlex>
    );
  };
  useEffect(() => {
    if (isEdit) {
      let isShow = hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.MODIFY,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report
      );
      if (isShow) {
        setIsDisabled(false);
      } else {
        setIsDisabled(true);
      }
    } else {
      setIsDisabled(false);
    }
  }, [isEdit]);
  useEffect(() => {
    console.log({ isDisabled, isEdit });
  }, [isDisabled]);
  return (
    <>
      <StyledGridRow justify={"end"} style={{ marginBottom: "15px" }}>
        <StyledGridCol>
          <Button
            type="default"
            color="default"
            onClick={handleBillingReport}
            disabled={
              billingData?.length === 0 ||
              !bookingsFieldsEnabled ||
              !hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.ADD,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Arrest_Report
              )
            }
          >
            Inmate Billing Report
          </Button>
        </StyledGridCol>
      </StyledGridRow>
      <StyledGridRow justify={"space-between"}>
        <StyledGridCol>
          <Button
            disabled={
              !bookingsFieldsEnabled ||
              !hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.ADD,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Arrest_Report
              )
            }
            onClick={addBilling}
          >
            ADD
          </Button>
        </StyledGridCol>
        <StyledGridCol>
          <Button
            disabled={
              !isRowSelected ||
              billingData?.length === 0 ||
              !hasCheckSecurity(
                Security_Types.functionality,
                Entity_types.subModule,
                LABELS_CAPITAL.VIEW,
                MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                SUB_MODULES_LIST_WITH_ID.Arrest_Report
              )
            }
            style={{ marginRight: "10px" }}
            onClick={() => clickBillingDetails("edit")}
          >
            Details
          </Button>
          <Popconfirm
            title="Delete the Billing Report"
            description="Are you sure to delete this Bill Report?"
            onConfirm={deleteBilling}
            onCancel={() => {}}
            okText="Yes"
            cancelText="No"
          >
            <Button
              color="primary"
              type="primary"
              style={{ marginLeft: "10px" }}
              disabled={
                !isRowSelected ||
                billingData?.length === 0 ||
                !bookingsFieldsEnabled ||
                !hasCheckSecurity(
                  Security_Types.functionality,
                  Entity_types.subModule,
                  LABELS_CAPITAL.DELETE,
                  MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
                  SUB_MODULES_LIST_WITH_ID.Arrest_Report
                )
              }
            >
              Delete
            </Button>
          </Popconfirm>
        </StyledGridCol>
      </StyledGridRow>

      <Modal
        header={"Inmate Billing Report"}
        show={showBillingDetails}
        size="xl"
        onHide={() => {
          setShowBillingDetails(false);
          setIsEdit(false);
        }}
        footerActions={[
          {
            key: "save",
            text: "Save",
            onClick: saveBillingReport,
            disabled: isDisabled,
          },
        ]}
        footerCloseAction={() => setIsEdit(false)}
        footerCloseActionText="Close"
      >
        <Form form={billingForm}>
          <StyledGridCol>
            <Row gutter={16}>
              <Col span={8}>
                <FormItem
                  label="Housed For"
                  name="housedFor"
                  required={!fullSearch}
                  rules={
                    !fullSearch
                      ? [
                          {
                            required: true,
                            message: "Housed For is required",
                          },
                        ]
                      : []
                  }
                >
                  <Select
                    options={getOptionsFromRefList(
                      "AnokaCommitmentAgency",
                      false,
                      false,
                      true
                    )}
                    disabled={!bookingsFieldsEnabled}
                    placeholder="Housed For"
                    showSearch={true}
                    variant="outlined"
                  />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem
                  label="Facility"
                  name="facilityID"
                  required={!fullSearch}
                  rules={
                    !fullSearch
                      ? [
                          {
                            required: true,
                            message: "Facility is required",
                          },
                        ]
                      : []
                  }
                >
                  <Select
                    options={getOptionsFromRefList(
                      "Housing_Agency",
                      false,
                      false,
                      true
                    )}
                    disabled={!bookingsFieldsEnabled}
                    placeholder="Facility"
                    showSearch={true}
                    variant="outlined"
                  />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem
                  label="Rate"
                  name="billingRate"
                  required={!fullSearch}
                  rules={
                    !fullSearch
                      ? [
                          {
                            required: true,
                            message: "Rate is required",
                          },
                        ]
                      : []
                  }
                >
                  <TextField
                    onChange={handleChange}
                    onBlur={handleBlur}
                    disabled={!bookingsFieldsEnabled}
                  />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem
                  label="Start Date"
                  name="startDate"
                  required={!fullSearch}
                  rules={
                    !fullSearch
                      ? [
                          {
                            required: true,
                            message: "Start Date is required",
                          },
                        ]
                      : []
                  }
                >
                  <CommonDatePicker
                    placeholder="MM/DD/YYYY"
                    showTime={false}
                    format="MM/DD/YYYY"
                    disabled={!bookingsFieldsEnabled}
                  />
                </FormItem>
              </Col>
              <Col span={8}>
                <FormItem
                  label="End Date"
                  name="endDate"
                  required={!fullSearch}
                  rules={
                    !fullSearch
                      ? [
                          {
                            required: true,
                            message: "End Date is required",
                          },
                        ]
                      : []
                  }
                >
                  <CommonDatePicker
                    placeholder="MM/DD/YYYY"
                    showTime={false}
                    format="MM/DD/YYYY"
                    disabled={!bookingsFieldsEnabled}
                  />
                </FormItem>
              </Col>
            </Row>
            <Row gutter={16}>
              <Col span={8}>
                <FormItem label="Comments" name="comments">
                  <TextField
                    inputType="textarea"
                    as="textarea"
                    id="description"
                    name="description"
                    variant="outlined"
                    rows="5"
                    disabled={!bookingsFieldsEnabled}
                  />
                </FormItem>
              </Col>
            </Row>
          </StyledGridCol>
        </Form>
      </Modal>

      {hasCheckSecurity(
        Security_Types.functionality,
        Entity_types.subModule,
        LABELS_CAPITAL.VIEW,
        MODULES_LIST_WITH_ID.MODULE_BOOKINGS,
        SUB_MODULES_LIST_WITH_ID.Arrest_Report
      ) && (
        <Table
          headers={headers}
          data={billingData.map((item) => {
            return {
              ...item,
              billingRate: formatCurrency(item?.billingRate?.toString()),
              housedForLbl: getFieldLabel(
                "AnokaCommitmentAgency",
                item.housedFor
              ),
              facilityLbl: getFieldLabel("Housing_Agency", item.facilityID),
            };
          })}
          onRowClick={patchSelectedData}
          onRowDoubleClick={(data) => {
            patchSelectedData(data);
            clickBillingDetails("edit");
          }}
          style={{ marginTop: "15px" }}
          selected={selectedRow === null}
        />
      )}
      {/* 
      {showBillingReport && (
        <CommonReportModal
          reportHeader={
            <BillingReportHeader billingReportResults={billingReportResults} />
          }
          hideInfoTableHeader={true}
          tableInfoFooter={
            <>
              <b>Grand Total Days</b>: {billingReportResults?.subTotalDays}{" "}
              &nbsp;
              <b>Grand Total</b>: ${billingReportResults?.subTotal}
            </>
          }
          reportData={{
            headers: [
              { key: "id", text: "#" },
              { key: "bookingNumber", text: "Booking Number" },
              { key: "name", text: "Name" },
              { key: "startDate", text: "Start Date" },
              { key: "endDate", text: "End Date" },
              { key: "housedFor", text: "Housed For" },
              { key: "billingRate", text: "Billing Rate" },
              { key: "daysToBill", text: "Days To Bill" },
              { key: "totalBill", text: "Total Bill" },
            ],
            data: billingReportResults?.inmateBillingDetailDtos || [],
          }}
          show={showBillingReport}
          onHide={() => setShowBillingReport(false)}
        />
      )} */}

      {billingReportOptionModal && (
        <CustomModal
          size="md"
          show={billingReportOptionModal}
          onHide={() => setBillingReportOptionModal(false)}
          onSaveClick={handleReportOptionSave}
        >
          <Form form={reportOptionsForm}>
            <StyledGridRow gutter={16}>
              <StyledGridCol xs={12}>
                <FormItem
                  label="Starting date"
                  name="startingDate"
                  rules={[
                    { required: true, message: "Starting date is required" },
                  ]}
                >
                  <CommonDatePicker
                    showTime={false}
                    placeholder="MM/DD/YYYY"
                    format="MM/DD/YYYY"
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol xs={12}>
                <FormItem
                  label="Ending date"
                  name="endingDate"
                  rules={[
                    { required: true, message: "Ending date is required" },
                  ]}
                >
                  <CommonDatePicker
                    showTime={false}
                    placeholder="MM/DD/YYYY"
                    format="MM/DD/YYYY"
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol xs={24}>
                <FormItem
                  label="Select Housing Agency"
                  name="facilityId"
                  rules={[
                    {
                      required: true,
                      message: "Housing Agency is required",
                    },
                  ]}
                >
                  <Select
                    options={getOptionsFromRefList(
                      "Housing_Agency",
                      false,
                      false,
                      true
                    )}
                    placeholder="Housing Agency"
                    showSearch={true}
                    variant="outlined"
                  />
                </FormItem>
              </StyledGridCol>
              <StyledGridCol xs={24}>
                <FormItem
                  label="Select Agency"
                  name="housedFor"
                  rules={[
                    {
                      required: true,
                      message: "Agency is required",
                    },
                  ]}
                >
                  <Select
                    options={getOptionsFromRefList("AnokaCommitmentAgency")}
                    placeholder="Agency"
                    showSearch={true}
                    variant="outlined"
                  />
                </FormItem>
              </StyledGridCol>
            </StyledGridRow>
          </Form>
        </CustomModal>
      )}
    </>
  );
};

export default BillingDetails;
